import { copyHome, makeHome } from 'src/home/store/utils/home'
import { createObject } from 'src/utils/objects'

const Getters = {
  setDefaultMetricSettings(state) {
    const { metricGroupByMap, metricTypeMap } = state
    return (endpointKey, home) => {
      const getDefaultMetricType = () => metricTypeMap[endpointKey][0].value
      const getDefaultMetricGroupBy = () => metricGroupByMap[endpointKey][0].value
      const metricGroupBy = getDefaultMetricGroupBy()
      const metricType = getDefaultMetricType()

      home.metricGroupBy = metricGroupBy
      home.metricType = metricType

      return home
    }
  },
  haveHomeSettings(state, getters, rootState, rootGetters) {
    const homeSettings = rootGetters['auth/homeSettings']
    return homeSettings && homeSettings.length
  },
  homeData(state, getters, rootState, rootGetters) {
    const { haveHomeSettings, setDefaultMetricSettings } = getters
    const homeSettings = rootGetters['auth/homeSettings']
    const networks = rootGetters['tools/networks']

    const baseReportName = 'pacing'
    const reportPath = 'all-data'
    const routeName = 'delivery'
    const setDefaultReportSettings = (home) => {
      home.baseReportName = baseReportName
      home.reportPath = reportPath
      home.routeName = routeName
    }

    const endpointKey = baseReportName || routeName

    const useNetworkSettings = () => networks.reduce((newNetworksArray, network, networkIndex) => {
      const home = copyHome(network, networkIndex)

      setDefaultReportSettings(home)
      setDefaultMetricSettings(endpointKey, home)

      newNetworksArray.push(home)

      return newNetworksArray
    }, [])

    const useHomeSettings = () => {
      const isMissingMetricSettings = (home) => !home.metricType || !home.metricGroupBy

      return homeSettings.map((home) => {
        if (isMissingMetricSettings(home)) {
          setDefaultMetricSettings(endpointKey, home)
        }

        return home
      })
    }

    return haveHomeSettings ? useHomeSettings() : useNetworkSettings()
  },
  homes(state, getters, rootState, rootGetters) {
    const { homeData } = getters
    const { searchResults } = rootState.tools
    const findSearchOption = rootGetters['tools/findSearchOption']
    const getSearchOptions = rootGetters['tools/getSearchOptions']

    return homeData.reduce((newHomesArray, homeSetting, index) => {
      const { associationId, baseReportName, reportPath, routeName, subId } = homeSetting
      const endpointKey = baseReportName || routeName
      const searchOptions = endpointKey && getSearchOptions(endpointKey, searchResults)
      const searchOption = searchOptions && findSearchOption(searchOptions, associationId, baseReportName, reportPath, routeName, subId)

      const { textAlt } = searchOption || {}
      const overwrites = { index, textAlt }

      const homeCard = createObject(homeSetting, overwrites)

      newHomesArray.push(homeCard)

      return newHomesArray
    }, []).sort((a, b) => a.index - b.index)
  },
  emptyHomeCard(state, getters) {
    const { homes } = getters
    return makeHome(homes.length)
  },
}

export default Getters
